import React, { useEffect, useState } from 'react'
import s from '../CreateQuiz.module.scss'
import { searchItems } from '../../Challenges/api';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import { useSelector, shallowEqual } from 'react-redux';

export const SelectProducts = ({ quiz, currentTableAnswer, addItemToChoice }) => {
    const { merchantId } = useSelector(
        (state) => ({
            merchantId: state.merchants.filter.merchantId,
        }),
        shallowEqual
    );
    const [itemsSearch, setItemsSearch] = useState('')
    const [emptySearch, setEmptySearch] = useState(false)
    const [searchedForItems, setSearchedForItems] = useState(false)
    const [items, setItems] = useState([])
    useEffect(() => {
        setSearchedForItems(true)
        const getItems = async () => {
            const itemsFound = await searchItems({ merchantId, key: itemsSearch });
            setEmptySearch(!itemsFound.length)
            if (itemsFound.length) {
                itemsFound.forEach((item) => {
                    item.price = item.price / 100;
                })
            }
            setItems(itemsFound)
        }
        if (itemsSearch && itemsSearch.length > 2) {
            const timeout = setTimeout(() => {
                getItems();
            }, 500);
            return () => clearTimeout(timeout);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsSearch])

    function searchItemsString(e) {
        setItemsSearch(e?.target?.value)
    }

    const price = (currency, cents, locale) => `${currency}${(cents).toLocaleString(locale)}`;

    return (
        <div className="card card-custom gutter-b ml-7" style={{ width: '516px' }}>
            <div className="card-header" style={{ border: 'initial' }}>
                <div className="card-title">
                    <div style={{
                        fontWeight: '400',
                        fontSize: '16px'
                    }}>
                        {currentTableAnswer ?
                            <>
                                Select products that are suitable for
                                <span style={{ fontWeight: '600' }}>&nbsp;{quiz.questions[0].answers[currentTableAnswer[0]].title}&nbsp;</span>
                                and
                                <span style={{ fontWeight: '600' }}>&nbsp;{quiz.questions[1].answers[currentTableAnswer[1]].title}</span>
                            </>
                            : null
                        }
                    </div>
                </div>
            </div>
            <div className="form-group mt-7" style={{ padding: '0 2.25rem' }}>
                <input
                    onInput={searchItemsString}
                    type="email"
                    className="form-control mb-2 form-control-solid form-control-lg"
                    placeholder="Search products from your store"
                    disabled={!currentTableAnswer.length}
                    style={{ borderRadius: '30px' }}
                />
                {emptySearch && searchedForItems ?
                    <div>No items found</div>
                    : null
                }
            </div>
            <Divider />
            <div className="card-body" style={{ padding: '0' }}>
                {items && items.length ?
                    <Grid container className={s.itemsContainer} style={{ gridGap: '8px' }}>
                        {items.map(item => (
                            <Grid className={s.item} key={item._id} >
                                <div
                                    style={{
                                        overflow: 'hidden',
                                        border: '0.5px solid #DEDFE0',
                                        height: '188px',
                                        width: '111px',
                                        borderRadius: '8px',
                                    }}
                                    title={item.title}
                                    onClick={e => addItemToChoice(item)}
                                >
                                    <img src={item.img} alt={item.title}
                                        data-id={item._id}
                                        title={item.title}
                                        dataprice={item.price}
                                        style={{
                                            height: '134px',
                                            width: '111px',
                                            objectFit: 'cover',
                                            objectPosition: 'top'
                                        }}
                                    />
                                    <div style={{
                                        fontWeight: '400',
                                        fontSize: '12px',
                                        display: '-webkit-box',
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: '2',
                                        overflow: 'hidden',
                                        padding: '0 4px',
                                        lineHeight: '14px',
                                        marginTop: '5px',
                                    }}>
                                        {item.title}
                                    </div>
                                    <div style={{
                                        fontWeight: '500',
                                        fontSize: '12px',
                                        color: '#717171d1',
                                        padding: '0 4px',
                                    }}>
                                        {price(item.currency, item.price, navigator.language)}
                                    </div>
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                    : null
                }
            </div>
        </div >
    )
}
